import { api } from './api'
import {
  PortalDashboardData,
  PortalMedicalRecordSummary,
  PortalMessageListResponse,
  PortalMessage,
  PortalMessageCreate,
  PortalAppointmentSummary,
  PortalInvoiceSummary,
  PortalPrescription,
  PortalPrescriptionRefillRequest,
  PortalAvailableSlot,
} from '@/types'

export const portalApi = {
  // Dashboard
  getDashboard: async (): Promise<PortalDashboardData> => {
    return api.get('/portal/dashboard')
  },

  // Medical Records
  getMedicalRecords: async (): Promise<PortalMedicalRecordSummary> => {
    return api.get('/portal/medical-records')
  },

  // Messages
  getMessages: async (folder = 'inbox', page = 1, pageSize = 20): Promise<PortalMessageListResponse> => {
    const params = new URLSearchParams()
    params.append('folder', folder)
    params.append('page', page.toString())
    params.append('page_size', pageSize.toString())
    return api.get(`/portal/messages?${params.toString()}`)
  },

  getMessage: async (messageId: string): Promise<PortalMessage> => {
    return api.get(`/portal/messages/${messageId}`)
  },

  sendMessage: async (data: PortalMessageCreate): Promise<PortalMessage> => {
    return api.post('/portal/messages', data)
  },

  // Appointments
  getAppointments: async (): Promise<PortalAppointmentSummary[]> => {
    return api.get('/portal/appointments')
  },

  // Billing
  getInvoices: async (): Promise<PortalInvoiceSummary[]> => {
    return api.get('/portal/billing/invoices')
  },

  // Prescriptions
  getPrescriptions: async (): Promise<PortalPrescription[]> => {
    return api.get('/portal/prescriptions')
  },

  requestRefill: async (data: PortalPrescriptionRefillRequest): Promise<void> => {
    return api.post('/portal/prescriptions/refill', data)
  },

  // Available Slots for Self-Scheduling
  getAvailableSlots: async (dateFrom: string, dateTo: string): Promise<PortalAvailableSlot[]> => {
    const params = new URLSearchParams()
    params.append('date_from', dateFrom)
    params.append('date_to', dateTo)
    return api.get(`/portal/appointments/available-slots?${params.toString()}`)
  },

  // Request Appointment
  requestAppointment: async (data: {
    preferred_date: string
    preferred_time?: string
    appointment_type: string
    reason?: string
    preferred_doctor_id?: string
    is_urgent: boolean
  }): Promise<void> => {
    return api.post('/portal/appointments/request', data)
  },
}
